
export const storeAlternative = async (resource,data) => {
    let alternative;
    await resource
      .post(`api/${localStorage.getItem('perfil')}/alternative`,data)
      .then(
        (response) => {
          console.log(response);
          alternative = response.body.alternative;
        },
        (response) => {
          console.log(response);
        }
      );
    return alternative;
  }
  